<template>
    <div class="hero-sass hero-swiper-btn" id="home">
        <div class="container_f1">
            <div class="hero-item text-center">
                <div class="hero-content">
                    <!--<video id="bg-video" playsinline="" autoplay="" muted="" loop="" @load="videoLoaded">
                        <source src="../assets/img/bg/cover.webm">
                    </video>-->

                    <h2 class="h1 hero-content-title font-weight-light">{{ $t("home.title") }}</h2>
                    <h6 class="hero-content-subtitle">{{ $t("home.subtitle") }}</h6>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            bgImg: {
                backgroundImage: `#ffffff`
            }
        };
    }
};
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variabls.scss';
    @import '../assets/scss/elements/hero-sass.scss';
</style>
